export const url = {
	link_cnx_home       : 'https://www.cnxhome.ph/',
	link_cnx_enterprise : 'https://enterprise.cortex.ph/',
	link_buddee         : 'https://www.buddee.ph/',
};
